import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const Issuance = () => {
  return <ErpTablePage moduleKey="inv_issuance" />;
};

export default Issuance;